import React from 'react'
import styles from "../style/components/shopModalContent.module.css"
import { Link } from 'react-router-dom'


const ShopModalContent = ({onClose}) => {
  return (
    <div className={styles.shopModalContent}>
        <Link className={styles.shopModalContentConcert} to={"/concertVideos"} onClick={onClose}>
        <img src='/concert.png' className={styles.shopModalConcertImg}/>
        <button className={styles.shopModalConcertBtn}>КОНЦЕРТЫ</button>
        </Link>

           <Link className={styles.shopModalContentMerch}  to={"/merch"} onClick={(e) => {
            e.preventDefault()
            alert("Фирменная продукция находится на стадии разработки")}}>
        <img src='/merch.png' className={styles.shopModalMerchImg}/>
        <button className={styles.shopModalMerchBtn}>МЕРЧ</button>
        </Link>
        
    </div>
  )
}

export default ShopModalContent
